<template>
    <div class="content-container">
        <div class="content" :class="{'h-auto': useManualAddress}">
            <div class="container">
                <loading-state v-if="loading"></loading-state>
                <div class="row" v-if="!loading">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>Repair location</h1>
                        </div>
                    </div>

                    <!-- Address Select -->
                    <template v-if="!useManualAddress">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{ selectLabel }} <span class="text-danger">*</span></label>
                                <select class="custom-select form-control" v-model="selectedAddress">
                                    <option value="default" disabled selected>Please select an address from the list</option>
                                    <option
                                            v-for="(address, key) in booking.auto_addresses"
                                            :key="key"
                                            :value="address">
                                        {{ parseAddressToString(address) }}
                                    </option>
                                </select>
                            </div>
                            <small @click="setManualAddressState(true)" class="cursor-pointer form-text text-underline">Enter location manually</small>
                        </div>
                    </template>

                    <!-- Manual Entry -->
                    <template v-if="useManualAddress">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Address line 1 <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="address.line_1">
                                <input-error :errors="addressFormErrors['address.line_1']"></input-error>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label>Address line 2</label>
                                <input type="text" class="form-control" v-model="address.line_2">
                                <input-error :errors="addressFormErrors['address.line_2']"></input-error>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label>Town / City <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="address.town">
                                <input-error :errors="addressFormErrors['address.town']"></input-error>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Postcode <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" readonly v-model="address.postcode">
                                <input-error :errors="addressFormErrors['address.postcode']"></input-error>
                            </div>
                        </div>
                        <div class="col-12" v-if="!useLoqate">
                            <small @click="setManualAddressState(false)" class="cursor-pointer form-text text-underline">Select address from list</small>
                        </div>
                    </template>
                    <!-- Footer -->
                    <footer class="footer" :class="{'fixed-footer': !useManualAddress}">
                        <div class="container">
                            <router-link :to="{ name: 'repairDates'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                            <button @click="initiateSetAddress()" class="btn btn-primary btn-lg continue-btn icon-right ml-auto" :disabled="!canContinue">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'SelectLocation',

        mounted() {

            if (this.useLoqate) {
                this.setManualAddressState(true);
            }

            this.checkCanBeOnPage();

            if (this.booking.address.line_1) {
                this.selectedAddress = this.booking.address;
                this.address = this.booking.address;
                delete this.selectedAddress.country;
            }

            this.address.postcode = this.booking.address.postcode;

            if (this.useLoqate && this.address.town === "Not Set") {
                this.address.town = null;
            }

            // if (this.landingPageLoadSuccess) {
            //     this.setManualAddressState(true);
            // }
        },

        data() {
            return {
                loading: true,
                address: {
                    line_1: null,
                    line_2: null,
                    postcode: null,
                    town: null
                },
                selectedAddress: 'default',
                addressFormErrors: []
            }
        },

        computed: {
            ...mapGetters([
                'booking',
                'landingPageLoadSuccess',
                'parseAddressToString',
                'useManualAddress',
                'wasBookedInStore',
                'storesWithDropOffEnabled',
                'isStoreDropOff',
                'bookingPostcode',
                'chosenDropOffStoreId',
                'isBookingInStore',
                'store',
                'useLoqate'
            ]),

            canContinue() {
                if (!this.useManualAddress && this.selectedAddress !== 'default') return true;

                return (
                    this.useManualAddress &&
                    this.address.line_1 &&
                    this.address.town &&
                    this.address.postcode
                );
            },

            selectLabel() {
                if (this.isBookingInStore) {
                    return "Please select the customer's address from the list";
                }

                return "Please select an address from the list";
            }
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'setAddress',
                'setManualAddressState',
                'displayToastFromResponseObjectOfErrors',
                'displayToast'
            ]),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.booking.date) {
                        this.$router.push({name: 'repairDates'});
                    }
                });

                if(this.isStoreDropOff) {
                    return this.getDropOffStoreData().then((store) => {
                        this.setAddress(store.address).then(() => {
                            this.$router.push({name: 'customerDetails'});
                        }).catch(errors => this.displayToastFromResponseObjectOfErrors(errors));
                    }).catch(() => this.displayToast({
                        text: 'Could not find store in getDropOffStoreData',
                        type: "error",
                        duration: 6000
                    }));
                }

                this.loading = false;
            },

            initiateSetAddress() {
                if (!this.canContinue) return;

                this.addressFormErrors = [];

                let address = this.selectedAddress;

                if (this.useManualAddress) {
                    address = this.address;
                }

                this.setAddress(address).then(() => {
                    this.$router.push({name: 'customerDetails'});
                }).catch((errors) => {
                    this.setManualAddressState(true);
                    this.addressFormErrors = errors.response.data.messages;
                })
            },

            getDropOffStoreData() {
                return new Promise((resolve, reject) => {
                    if (this.store.id === this.chosenDropOffStoreId) return resolve(this.store); // A store has already been set. We don't need to do it again.

                    let store = this.storesWithDropOffEnabled.find((store) => {
                        return store.id === this.chosenDropOffStoreId
                    });
                    (store) ? resolve(store) : reject();
                });
            },
        }
    }
</script>

<style scoped>

</style>